import type { ReactNode } from 'react';
import { useConnection, useReady, useStale } from '../lib/hooks.js';
import { useOnline } from '../lib/online.js';
import { Icon } from '../lib/icons.js';

/** Small floating banner while the socket is down; the last known state stays on screen. */
export function ConnectionBanner(): ReactNode {
  const status = useConnection();
  const ready = useReady();
  const online = useOnline();
  const stale = useStale();
  if (status === 'live' && stale && online) return null; // live snapshots land within a few hundred ms
  if (status === 'live' || status === 'idle' || status === 'revoked' || status === 'unauthenticated') {
    if (online) return null;
  }
  if (status === 'connecting' && !ready) return null;
  const label = !online
    ? "You're offline. Showing the last known state."
    : stale
      ? 'Showing saved data. Connecting…'
      : 'Reconnecting…';
  return (
    <div className="conn-banner glass glass-raised" role="status" data-testid="conn-banner">
      <Icon name="wifi-off" size={15} />
      {label}
    </div>
  );
}
